import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../api/axios';

const SelectSala = () => {
    const { user, updateUser } = useAuth();
    const navigate = useNavigate();
    const [salas, setSalas] = useState([]);
    const [selectedSalaId, setSelectedSalaId] = useState(user?.sala_id || '');
    const [isSubmittingSala, setIsSubmittingSala] = useState(false);
    const [salaError, setSalaError] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [successMsg, setSuccessMsg] = useState('');

    useEffect(() => {
        const fetchSalas = async () => {
            try {
                const res = await api.get('/salas');
                setSalas(res.data);
                if (!selectedSalaId && res.data.length > 0) {
                    const salaGeneral = res.data.find(s => s.id === 1);
                    if (salaGeneral) {
                        setSelectedSalaId(salaGeneral.id);
                    }
                }
            } catch (err) {
                console.error("Error fetching salas", err);
                setSalaError("Error al cargar las salas.");
            } finally {
                setIsLoading(false);
            }
        };

        fetchSalas();
    }, [selectedSalaId]);

    const handleSaveSala = async () => {
        if (!selectedSalaId) {
            setSalaError('Por favor selecciona una sala para continuar.');
            return;
        }
        setIsSubmittingSala(true);
        setSalaError('');
        setSuccessMsg('');
        
        try {
            const res = await api.put('/users/profile/update', { sala_id: selectedSalaId });
            updateUser(res.data.user);
            setSuccessMsg('Sala actualizada correctamente.');
            setTimeout(() => {
                navigate('/agenda');
            }, 1500);
        } catch (err) {
            console.error("Error updating sala", err);
            setSalaError('Error al asignar la sala, por favor intenta de nuevo.');
        } finally {
            setIsSubmittingSala(false);
        }
    };

    if (isLoading) {
        return (
            <div className="flex flex-col items-center justify-center py-40 animate-pulse">
                <div className="w-12 h-12 border-4 border-white/10 border-t-purple-500 rounded-full animate-spin"></div>
                <p className="mt-4 text-[10px] font-black uppercase tracking-widest text-white/20">Cargando salas...</p>
            </div>
        );
    }

    return (
        <div className="max-w-xl mx-auto py-10 px-4 animate-fadeIn">
            <header className="mb-10 text-center">
                <span className="text-6xl mb-4 block drop-shadow-lg">🏢</span>
                <h2 className="text-4xl font-black text-white italic uppercase tracking-tighter">Mi Sala</h2>
                <p className="text-white/60 text-sm mt-2 font-medium">
                    Selecciona o actualiza la sala en la que te encuentras participando.
                </p>
            </header>

            <div className="bg-white/10 backdrop-blur-xl p-8 rounded-[40px] border border-white/10 shadow-2xl">
                <div className="space-y-6">
                    <div>
                        <label className="block text-[10px] font-black text-white/40 uppercase tracking-[0.2em] mb-3 ml-2">Sala Asignada</label>
                        <div className="relative">
                            <select
                                className="w-full bg-white/5 border border-white/10 text-white p-4 rounded-2xl focus:outline-none focus:ring-4 focus:ring-purple-500/20 transition-all appearance-none"
                                value={selectedSalaId}
                                onChange={(e) => setSelectedSalaId(e.target.value)}
                            >
                                <option value="" disabled className="bg-slate-900 text-white">Selecciona una sala...</option>
                                {salas.map(s => (
                                    <option key={s.id} value={s.id} className="bg-slate-900 text-white">
                                        {s.name} {s.ubication ? `(${s.ubication})` : ''}
                                    </option>
                                ))}
                            </select>
                            <div className="absolute right-4 top-1/2 -translate-y-1/2 text-white/50 pointer-events-none">▼</div>
                        </div>
                    </div>

                    {salaError && (
                        <div className="bg-red-500/20 text-red-400 text-xs font-bold p-3 rounded-2xl text-center">
                            {salaError}
                        </div>
                    )}
                    
                    {successMsg && (
                        <div className="bg-emerald-500/20 text-emerald-400 text-xs font-bold p-3 rounded-2xl text-center">
                            {successMsg}
                        </div>
                    )}

                    <button
                        onClick={handleSaveSala}
                        disabled={isSubmittingSala || !selectedSalaId || selectedSalaId === String(user?.sala_id)}
                        className="w-full bg-gradient-to-r from-purple-600 to-indigo-600 text-white py-4 rounded-3xl font-black uppercase tracking-widest text-[11px] shadow-lg hover:scale-[1.02] active:scale-95 transition-all disabled:opacity-50"
                    >
                        {isSubmittingSala ? 'PROCESANDO...' : 'GUARDAR CAMBIOS'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SelectSala;
